import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 27.442 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M18.837 0H8.852c-.956 0-1.728.785-1.728 1.75v20.538c0 .965.772 1.749 1.728 1.749h9.985c.954 0 1.727-.784 1.727-1.75V1.752A1.74 1.74 0 0 0 18.837 0M11.38 1.063h4.93c.125 0 .226.189.226.422s-.101.422-.226.422h-4.93c-.125 0-.225-.19-.225-.422s.1-.422.225-.422m2.465 21.246c-.608 0-1.102-.501-1.102-1.118s.494-1.116 1.102-1.116c.606 0 1.101.5 1.101 1.116s-.495 1.118-1.1 1.118m5.425-3.827H8.42V2.954h10.85z"
    }, null, -1)
  ])))
}
export default { render: render }